export default __webpack_public_path__ + "static/media/Venturer's Girdle of the Primeval.8d1f7971.jpg";